import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import ListTableItem from "./ListTableItem";
import { Box, Typography } from "@material-ui/core";
import ListTableHeading from "./ListTableHeading";
import EventsRequests from "services/events";

const EventTokenTable = () => {
  const dispatch = useDispatch();
  const { eventTicketTokenList } = useSelector(({ events }) => events);

  useEffect(() => {
    dispatch(EventsRequests.getEventTicketTokenList());
  }, []);

  return (
    <div className="Cmt-table-responsive">
      {eventTicketTokenList &&
        (eventTicketTokenList.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <ListTableHeading />
            </TableHead>
            <TableBody>
              {eventTicketTokenList.map((item) => (
                <ListTableItem item={item} key={item._id} />
              ))}
            </TableBody>
          </Table>
        ))}
    </div>
  );
};

export default EventTokenTable;
